import {FirebaseAppProvider} from 'reactfire';

import {ReactFireAuthProvider} from './ReactFireAuthProvider';

const firebaseConfig = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  appId: process.env.NEXT_PUBLIC_FIREBASE_API_ID,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
};

/**
 * This provider only performs **initialization related tasks** for Firebase
 * integration.
 *
 * For general usage and utility functions, either use the `useFirebase` hook
 * or standalone functions provided by the `useFirebase` hook.
 */
export const AuthProvider = ({children}: {children?: React.ReactNode}) => {
  return (
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <ReactFireAuthProvider>{children}</ReactFireAuthProvider>
    </FirebaseAppProvider>
  );
};
